module.exports = __webpack_public_path__ + "img/smile.4c30bd30.png";